const selectors = {
  frame: '[data-ticker-frame]',
  scale: '[data-ticker-scale]',
  text: '[data-ticker-text]',
  clone: 'data-clone',
  animationClass: 'ticker--animated',
  unloadedClass: 'ticker--unloaded',
  comparitorClass: 'ticker__comparitor',
};

const sections = {};

class Ticker {
  constructor(el) {
    this.frame = el;
    this.scale = this.frame.querySelector(selectors.scale);
    this.text = this.frame.querySelector(selectors.text);

    this.comparitor = this.text.cloneNode(true);
    this.comparitor.classList.add(selectors.comparitorClass);
    this.frame.appendChild(this.comparitor);
    this.scale.classList.remove(selectors.unloadedClass);
    this.listen();
  }
  unload() {
    document.removeEventListener('theme:resize', this.checkWidth);
  }
  listen() {
    document.addEventListener('theme:resize', this.checkWidth.bind(this));
    this.checkWidth();
  }
  checkWidth() {
    if (this.frame.clientWidth < this.comparitor.clientWidth) {
      this.text.classList.add(selectors.animationClass);
      if (this.scale.childElementCount === 1) {
        this.clone = this.text.cloneNode(true);
        this.clone.setAttribute('aria-hidden', true);
        this.clone.setAttribute(selectors.clone, '');
        this.scale.appendChild(this.clone);
      }
    } else {
      let clone = this.scale.querySelector(`[${selectors.clone}]`);
      if (clone) {
        this.scale.removeChild(clone);
      }
      this.text.classList.remove(selectors.animationClass);
    }
  }
}

const ticker = {
  onLoad() {
    sections[this.id] = [];
    const el = this.container.querySelectorAll(selectors.frame);
    el.forEach(el => {
      sections[this.id].push(new Ticker(el));
    });
  },
  onUnload: function() {
    sections[this.id].forEach(el => {
      if (typeof el.unload === 'function') {
        el.unload();
      }
    });
  },
};

export default ticker;

